<template>
  <div class="image-wrapper" v-if="showImage()">
    <template v-if="actionType === 'PHONE' && isUserActionAllow">
      <a v-tel="linkURLAll" ref="linktel" class="external">
        <div v-if="imageHeight !== 'auto'" class="cover-background" :style="ImageStyle"></div>
        <img v-if="imageHeight === 'auto'" :src="ImageUrl" width="100%">
      </a>
    </template>
    <template v-else-if="actionType === 'EMAIL' && isUserActionAllow">
      <a v-mailto="linkURLAll" ref="linkmail" class="external">
        <div v-if="imageHeight !== 'auto'" class="cover-background" :style="ImageStyle"></div>
        <img v-if="imageHeight === 'auto'" :src="ImageUrl" width="100%">
      </a>
    </template>
    <template v-else>
      <div v-if="imageHeight !== 'auto'" @click="onClickImage()" class="cover-background" :style="ImageStyle"></div>
      <img v-if="imageHeight === 'auto'" :src="ImageUrl" width="100%" @click="onClickImage()">
      <app-image-full-screen ref="pb" :photos="photos"></app-image-full-screen>
    </template>
  </div>
  <div class="image-wrapper" v-else>
    <div class="cover-background no-image" :style="NoImageStyle"></div>
  </div>
</template>

<script>
import {
  mapGetters
}
from 'vuex'
import { IsNullOrEmpty, showURL, calculateHeight } from '@/modules/helper/index'
import ImageFullScreen from '@/components/shared/ImageFullScreen.vue'
import { IsUserActionAllow, showExternalURL } from "@/modules/helper/index";
import DeviceInfo from '@/modules/util/deviceInfo';

export default {
  props: {
    linkURL: {
      type: String,
      default: '#'
    },
    imageHeight: {
      type: String,
      default: 'medium'
    },
    imageName: {
      type: String
    },
    actionType: {
      type: String,
      default: 'NONE'
    }
  },
  computed: {
    ...mapGetters([
      'DesignSettings',
      'resource'
    ]),
    ImageStyle() {
      let Height = calculateHeight(this.imageHeight)
      return {
        'height': `${Height}px`,
        'background-image': `url(${this.$store.getters.AppConfig.Urls.ContentAssetsBaseUrl + this.imageName})`
      }
    },
    isUserActionAllow() {
      return IsUserActionAllow()
    },
    NoImageStyle() {
      let Height = calculateHeight(this.imageHeight)
      return {
        'height': `${Height}px`
      }
    },
    ImageUrl() {
      return this.$store.getters.AppConfig.Urls.ContentAssetsBaseUrl + this.imageName
    },
    photos() {
      return [{url: this.$store.getters.AppConfig.Urls.ContentAssetsBaseUrl + this.imageName}]
    },
    linkURLAll() {
      return this.linkURL
    }
  },
  methods: {
    showMessage() {
      let modalOptions = {
        title: this.resource.warningTitle,
        text: this.resource.warningMessage,
        buttonText: this.resource.closeBtn,
        downloadbuttonText: DeviceInfo.isAndroid
          ? this.resource.AndroidDownload
          : this.resource.AppleDownload,
        $f7: this.$f7
      };
      this.$showModal(modalOptions)
    },
    showImage() {
      if (IsNullOrEmpty(this.imageName)) {
        return false
      }
      return true
    },
    onClickImage() {
      if ((this.actionType === 'PHONE' || this.actionType === 'EMAIL') && !this.isUserActionAllow) {
        this.showMessage()
      }
      else if (this.actionType === 'WEBSITE' && !IsNullOrEmpty(this.linkURL)) {
        showURL(this.linkURL, this.DesignSettings.AppThemeColor, this.DesignSettings.AppThemeFontColor)
      } else if (this.actionType === 'EXTERNAL' && !IsNullOrEmpty(this.linkURL)) {
          showExternalURL(this.linkURL)
       } else if (this.actionType === 'APP_NAVIGATION' || this.actionType === 'HOME') {
        this.$f7.views.main.router.navigate(`/${this.linkURL}`)
      } else if (this.actionType === 'FULL_SCREEN') {
        this.$refs.pb.$children[0].open()
      }
    }
  },
  components: {
    appImageFullScreen: ImageFullScreen
  }
}
</script>
<style scoped>
  /* .image-wrapper{
    padding: 10px 0px!important;
  } */
</style>



// WEBPACK FOOTER //
// src/components/stacked-elements/content-control/Image.vue